/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertFaxProfileDto
 */
export interface UpsertFaxProfileDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertFaxProfileDto
     */
    sinchServiceId: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertFaxProfileDto
     */
    faxNumber: string;
}

/**
 * Check if a given object implements the UpsertFaxProfileDto interface.
 */
export function instanceOfUpsertFaxProfileDto(value: object): value is UpsertFaxProfileDto {
    if (!('sinchServiceId' in value) || value['sinchServiceId'] === undefined) return false;
    if (!('faxNumber' in value) || value['faxNumber'] === undefined) return false;
    return true;
}

export function UpsertFaxProfileDtoFromJSON(json: any): UpsertFaxProfileDto {
    return UpsertFaxProfileDtoFromJSONTyped(json, false);
}

export function UpsertFaxProfileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertFaxProfileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sinchServiceId': json['sinchServiceId'],
        'faxNumber': json['faxNumber'],
    };
}

export function UpsertFaxProfileDtoToJSON(json: any): UpsertFaxProfileDto {
    return UpsertFaxProfileDtoToJSONTyped(json, false);
}

export function UpsertFaxProfileDtoToJSONTyped(value?: UpsertFaxProfileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sinchServiceId': value['sinchServiceId'],
        'faxNumber': value['faxNumber'],
    };
}

